import { useState } from "react";
import { useApp } from "../store.jsx";

export default function LoginScreen() {
  const { login } = useApp();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr]   = useState(null);

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await login(password);
    } catch (e) {
      setErr(/401/.test(String(e.message)) ? "Wrong password." : String(e.message));
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={onSubmit}>
        <div className="brand">NYCE AI STRATEGY</div>
        <h1>Sign in</h1>
        <p className="sub">Shared access password required.</p>
        <input
          type="password"
          autoFocus
          autoComplete="current-password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={busy}
        />
        {err && <div className="login-err">{err}</div>}
        <button className="btn primary" type="submit" disabled={busy || !password}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
